<template>

    <div class="combined-filter-component" ref="root">

        <div class="contents">


            <div class="primary-filters">

                <div class="content-title-container" >
                    <h2 v-if="showContentTitle">{{contentTitle}}</h2>

                    <div class="clear-landingpage-filters" :class="{'active-filter': totalCriteriaCount > 0}">
                        <span>
                            <span class="active-filter-count">{{ totalCriteriaCount }}</span>
                            <span v-if="totalCriteriaCount == 0">{{ resetFilters_Btn_NoFilterText }}</span>
                            <span v-else>
                                {{ resetFilters_Btn_Text }}
                            </span>
                        </span>
                        <button type="button" @click="clearFilters" :disabled="totalCriteriaCount == 0" class="btn ">
                            <i class="fal fa-times fa-fw"></i>
                        </button>
                    </div>
                </div>

                <div class="pf-row" 
                     @click="onLocationClicked"
                     :class="{'-selected': locationSelectionDisplay.hasSelection, 'show':showLocationPicker }"
                     >
                    <i class="icon fal fa-fw fa-map-marker-alt" ></i>
                    <i v-if="locationSelectionDisplay.hasSelection" class="remove-selection fal fa-times" @click.stop="clearLocationInput"></i>
                    <i class="edit fal fa-fw fa-pencil" ></i>
                    <i class="edit -open-icon fal fa-fw fa-chevron-up" ></i>
                    <span class="d-block" >
                        {{locationSelectionDisplay.displayValue}}
                    </span>
                </div>
                <div class="pf-details-row"
                     :class="{'show':showLocationPicker }">

                    <location-picker-2023 :is-inline-styled="true"
                                          
                                          :hide-confirm-button="true"
                                          :is-auto-confirm="true" 
                                          :filter-selection-location="filter.location"                                        
                                          @location-confirmed="onLocationSelected"
                                          @on-clear-location-input="clearLocationInput"
                                          @on-clear-landing-page-filters="clearLandingPageFilters">
                    </location-picker-2023>
                </div>
                <div class="pf-row"
                     :class="{'-selected': datesSelectionDisplay.hasSelection, 'show':showDatesPicker }"
                     @click="onDatesClicked">

                    <i class="icon fal fa-fw fa-calendar-alt"></i>
                    <i v-if="datesSelectionDisplay.hasSelection" class="remove-selection fal fa-times" @click.stop="clearDateInput"></i>
                    <i class="edit fal fa-fw fa-pencil"></i>
                    <i class="edit -open-icon fal fa-fw fa-chevron-up"></i>

                    {{datesSelectionDisplay.displayValue}}
                </div>
                <div class="pf-details-row" id="arrival-departure-picker-row"
                     :class="{'show':showDatesPicker }">

                    <Suspense>
                        <template #default>

                            <arrival-departure-picker :display-constrained="true"
                                                      :should-detect-became-visible="true"
                                                      :became-visible="showDatesPicker"
                                                      :hide-no-preference-button="true"
                                                      :arrival-date="filter.date.arrival"
                                                      :default-date="filter.date.default"
                                                      :departure-date="filter.date.departure"
                                                      @noDatePreference="onDatesSelected"
                                                      @reset-date="clearDateInput"
                                                      @selection-confirmed="onDatesSelected"></arrival-departure-picker>

                        </template>
                        <template #fallback>
                            <span>
                                <i class="fal fa-3x fa-spinner fa-spin"></i>
                            </span>
                        </template>


                    </Suspense>
                </div>

                <div class="pf-row"
                     :class="{'-selected': guestsSelectionDisplay.hasSelection, 'show':showGuestsPicker }"
                     @click="onGuestsClicked">
                    <i class="icon fal fa-fw fa-users"></i>
                    <i class="edit fal fa-fw fa-pencil"></i>
                    <i class="edit -open-icon fal fa-fw fa-chevron-up"></i>

                    {{guestsSelectionDisplay.displayValue}}
                </div>
                <div class="pf-details-row"
                     :class="{'show':showGuestsPicker }">
                    <companions-picker :hide-chrome="true"
                                       v-bind:model="filter.companions"></companions-picker>
                </div>



            </div>

            <div id="searchFilterContainer">


                <div id="filter-header-container">

                    <div class="ph-accommodation-count">
                        <span>{{totalCount}}</span>&nbsp;{{i18n.filterPartial_Label_AccomodationsFound}}
                    </div>



                 
                </div>

                <div id="filter-sort-container">

                    <select v-model="filter.orderBy" class="form-control">
                        <option value="">{{i18n.filterPartial_Label_SortBy}}</option>
                        <option :value="SearchOrderingOption.PriceAsc"> {{i18n.filterPartial_Label_SortBy_Price_LowFirst}}</option>
                        <option :value="SearchOrderingOption.PriceDesc"> {{i18n.filterPartial_Label_SortBy_Price_HighFirst}}</option>
                        <option :value="SearchOrderingOption.MaxGuestCountAsc"> {{i18n.filterPartial_Label_SortBy_TotalPerson_LowFirst}}</option>
                        <option :value="SearchOrderingOption.MaxGuestCountDesc"> {{i18n.filterPartial_Label_SortBy_TotalPerson_HighFirst}}</option>
                        <option :value="SearchOrderingOption.Default"> {{i18n.filterPartial_Label_SortBy_Standard}}</option>
                    </select>

                    <div v-if="displaySortingMessage" class="sortingMessageNoDates">

                        {{i18n.filterPartial_Label_CalculatePriceWhenDateChange}}

                    </div>


                    <div class="clear-landingpage-filters" v-if="false">

                     {{resetFilters_Btn_Text}}
                        <button type="button" @click="clearFilters" class="btn ">
                            <i class="fal fa-times fa-fw"></i>
                        </button>
                    </div>


                </div>
                <!--<div v-if="false" class="accommodation-type-container" v-show="false">
                    <h4>@SearchResources.FilterPartial_Label_AccomodationType</h4>
                    <div class="custom-control custom-checkbox no-preference" :class="{checked:searchModel.filter.accommodationTypeNoPreference }"
                         @@click="accommodationTypeActions.toggleAll">
                        <label class="custom-control-label" for="selectAllTypes"> @SearchResources.FilterPartial_Label_All</label>
                    </div>
                    <div class="accommodation-type-options">


                        @foreach (var at in filterDefinition.AccommodationTypes)
                        {

                        <div class="custom-control custom-checkbox accommodation-type">
                            <input type="checkbox"
                                   class="custom-control-input" id="AccommodationTypes@(at.ValueId)"
                                   v-bind:checked="accommodationTypeActions.isChecked(@at.ValueId)" @@click="accommodationTypeActions.toggle(@at.ValueId)" />
                            <label class="custom-control-label" for="AccommodationTypes@(at.ValueId)"> @at.Name</label>
                        </div>

                        }
                    </div>
                </div>-->

                <div class="search-properties">

                    <h4>{{i18n.filterPartial_Label_RoomBeds}}</h4>
                    <div>
                        <amount-picker v-model="filter.bedrooms"
                                       name="nrOfBedrooms"
                                       :max="20"
                                       :min="0"
                                       :label="i18n.filterPartial_Label_Bedrooms"></amount-picker>
                    </div>
                    <div>
                        <amount-picker v-model="filter.bathrooms"
                                       name="nrOfBathrooms"
                                       :max="6"
                                       :min="0"
                                       :label="i18n.filterPartial_Label_Bathrooms"></amount-picker>
                    </div>

                </div>
                <div class="search-criteria">
                    <h4 class="title">{{i18n.filterPartial_Label_RefineYourSearch}}</h4>
                    <div class="group">

                        <div class="accordion">


                            <div class="search-criteria-group" v-for="(gr, grIndex) in def.searchCriteriaGrouping" key="gr.keyId">

                                <a class="expand-button collapsed" data-toggle="collapse" :data-target="'#gr'+grIndex">
                                    <div class="group-title">
                                        {{gr.name}}
                                        <div class="group-counter" v-show="criteriaActions.count(grIndex) > 0">
                                            <i>{{criteriaActions.count(grIndex)}}</i>
                                        </div>
                                    </div>
                                    <span class="show-more expand">{{i18n.filterPartial_Label_View}}</span>
                                    <span class="show-less expand">{{i18n.filterPartial_Label_Close}}</span>
                                </a>


                                <div :id="'gr'+grIndex" class="collapse">

                                    <div v-for="cr in gr.items" class="custom-control custom-checkbox search-criterion" key="cr.keyId">
                                        <input type="checkbox"
                                               class="custom-control-input" :id="'customCheck-' +cr.keyId"
                                               v-bind:checked="criteriaActions.isChecked(grIndex, cr.keyId)"
                                               @click="criteriaActions.toggle(grIndex, cr.keyId)" />
                                        <label class="custom-control-label" :for="'customCheck-' + cr.keyId"> {{cr.name}}</label>
                                    </div>


                                </div>
                            </div>



                        </div>



                    </div>

                </div>




            </div>

        </div>
    </div>


</template>


<script src="./CombinedFilterComponent.ts" lang="ts"></script>
<style src="./CombinedFilterComponent.css"></style>